import moment from 'moment';

/** UTC calendar days from `begin` through `end` inclusive, as `YYYY-MM-DD`. */
export function buildUtcDateRange(begin: string, end: string): string[] {
  if (!begin || !end) return [];

  const dates: string[] = [];
  const cursor = moment.utc(begin).startOf('day');
  const endDay = moment.utc(end).startOf('day');

  while (cursor.isSameOrBefore(endDay, 'day')) {
    dates.push(cursor.format('YYYY-MM-DD'));
    cursor.add(1, 'day');
  }

  return dates;
}

export function capitalizeFirst(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
